<app-navbar [blue]="true" [showCalibrationsNav]="true"></app-navbar>
<router-outlet></router-outlet>
